export enum ModeView {
    VIEW = 'VIEW',
    EDIT = 'EDIT',
    CREATE = 'CREATE'
}
